import React from "react"
import MemberList from './Reports/MemberList'
import SummaryReport from './Reports/SummaryReport'
import DetailReportContainer from "./Reports/DetailReportContainer";
import RebateAdjust from "./Reports/RebateAdjust"
import ReceiptsContainer from "./Reports/ReceiptsContainer"

const Reports = props => {
  let report
  switch (props.match.params.report) {
    case "memberlist":
      report = "Member List";
      return <MemberList title={report}  {...props} />
      //break
    case "rebateAdjust":
      report = "Report % Adjustment"
      return <RebateAdjust title={report} {...props} />
      //break
    case "contrSummary":
      report = "Contribution Summary"
      return <SummaryReport title={report} {...props} />
      //break
    case "contrDetails":
      report = "Contribution Details"
      return <DetailReportContainer title={report} {...props} />
      //break
    case "receipts":
      report = "Receipts"
      return <ReceiptsContainer title={report} {...props} />
    default:
      report = "unknown: something wrong here"
  }

  console.log(typeof report)

  return (
    <div className="Reports">
      
     
    </div>
  );
};

export default Reports;
